import { Section } from "@src/Components/StyledUtils"
import { VIEW_PATHS } from "@src/Routes/constants"
import { colors } from "@src/theme"
import * as React from "react"
import { useHistory } from "react-router-dom"

import {
  ConciergeNotifications,
  CyberConciergeCardStyled,
  VerticalSeparator,
} from "../styles"

interface IFilledStateCard {
  numberOfWeaknesses: number
  numberOfMessages: number
}

export const FilledStateCard = ({
  numberOfWeaknesses,
  numberOfMessages,
}: IFilledStateCard) => {
  const history = useHistory()
  return (
    <CyberConciergeCardStyled>
      <div>
        <Section
          fontColor={numberOfWeaknesses > 0 ? colors.darkBlue : colors.black}
          fontSize="32px"
          fontWeight="700"
          margin="16 0 10"
        >
          {numberOfWeaknesses > 0 ? (
            <ConciergeNotifications
              onClick={() => {
                history.push(`${VIEW_PATHS.cyberconcierge}/weaknesses`)
              }}
            >
              {numberOfWeaknesses}
            </ConciergeNotifications>
          ) : (
            <span>{numberOfWeaknesses}</span>
          )}
        </Section>
        <Section fontSize="16px" align="center">
          <div>{`Security Weakness${
            numberOfWeaknesses > 1 || numberOfWeaknesses === 0 ? "es" : ""
          }`}</div>
          <div>{`Require${numberOfWeaknesses === 1 ? "s" : ""} Attention`}</div>
        </Section>
      </div>
      <VerticalSeparator />
      <div>
        <Section
          fontColor={numberOfMessages > 0 ? colors.darkBlue : colors.black}
          fontSize="32px"
          fontWeight="700"
          margin="16 0 10"
        >
          {numberOfMessages > 0 ? (
            <ConciergeNotifications
              onClick={() => {
                history.push(`${VIEW_PATHS.cyberconcierge}/messages`)
              }}
            >
              {numberOfMessages}
            </ConciergeNotifications>
          ) : (
            <span>{numberOfMessages}</span>
          )}
        </Section>
        <Section fontSize="16px" align="center">
          <div>{`Concierge Message${
            numberOfMessages > 1 || numberOfMessages === 0 ? "s" : ""
          }`}</div>
        </Section>
      </div>
    </CyberConciergeCardStyled>
  )
}
